import { NgModule } from '@angular/core';
import { TopbarComponent } from './components/topbar/topbar.component';
import { PublicNavigationComponent } from './components/public-navigation/public-navigation.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { WriteActionDirective } from './directives/write-action.directive';

@NgModule({
  imports: [CommonModule, RouterModule, HttpClientModule, ReactiveFormsModule],
  exports: [
    TopbarComponent,
    PublicNavigationComponent,
    ChangePasswordComponent,
    WriteActionDirective,
  ],
  declarations: [
    TopbarComponent,
    PublicNavigationComponent,
    ChangePasswordComponent,
    WriteActionDirective,
  ],
  providers: [],
})
export class SharedModule {}
